"use strict";

import Common from "../Common";
import CommonGame from "../CommonGame";


//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
export default class UITopBarSharedControls extends PIXI.Container {
    constructor() {
        super();

        // Attributes.
        this._homeBtn = null;
        this._muteBtn = null;
        this._backBtn = null;

        // Signals.
        this.signals = {};
        this.signals.onBackBtn_Click = new signals.Signal();
    }

    init() {

        this._homeBtn = createButton("home");
        this._homeBtn.anchor = new PIXI.Point(0, 0.5);
        this._homeBtn.position.y = this._homeBtn.height * 0.5 + 30;
        this._homeBtn.visible = false;
        this._homeBtn._icon.scale.x = -1;
        this._homeBtn.overSoundName = "sfx_ui_rollover_00";
        this._homeBtn.downSoundName = "sfx_ui_click_00";
        this._homeBtn.signals.click.add(this._onHomeButton_Click, this);
        this.addChild(this._homeBtn);

        // Mute button.
        this._muteBtn = createButton("sound");
        this._muteBtn.anchor = new PIXI.Point(1, 0.5);
        this._muteBtn.position.y = this._homeBtn.position.y;
        this._muteBtn.visible = false;
        this._muteBtn.overSoundName = "sfx_ui_rollover_00";
        this._muteBtn.downSoundName = "sfx_ui_click_00";
        this._muteBtn.signals.click.add(this._onMuteButton_Click, this);
        this.addChild(this._muteBtn);

        // Back button.
        this._backBtn = createButton("back");
        this._backBtn.anchor = new PIXI.Point(0, 0.5);
        this._backBtn.position.y = this._homeBtn.position.y;
        this._backBtn.overSoundName = "sfx_ui_rollover_00";
        this._backBtn.downSoundName = "sfx_ui_click_00";
        this._backBtn.signals.click.add(this._onBackButton_Click, this);
        this._backBtn.visible = false;
        this.addChild(this._backBtn);
    }

    resize() {
        this._homeBtn.position.x = Common.getScreenPositionLeft() + 70;
        this._muteBtn.position.x = Common.getScreenPositionRight() - 70;
        this._backBtn.position.x = Common.getScreenPositionLeft() + 70;
    }

    _onHomeButton_Click() {
        //todo swap for signals
        Common.main.application.loadScene(CommonGame.SCENE_ID_MAIN);
    }

    _onMuteButton_Click() {
        Common.isMute = !Common.isMute;

        // TODO:
        this._muteBtn._icon.texture = Common.assets.getTexture(Common.isMute ? "icon_mute_off" : "icon_sound_off");
        this._muteBtn._currentIconTexture = this._muteBtn._icon.texture;

        Common.audio.mute(Common.isMute);

        // Sfx.
        //Common.audio.playSound( "sfx_small_blip" );
    }

    _onBackButton_Click() {
        this.signals.onBackBtn_Click.dispatch();
    }

    get homeBtn() {
        return this._homeBtn;
    }

    get muteBtn() {
        return this._muteBtn;
    }

    get backBtn() {
        return this._backBtn;
    }
}
